'use strict';

/**
 * Module dependencies
 */
var angular = require('angular');

module.exports = angular
  .module('app.core-utilities.countUp', [])
  .service('$countUp', [
    '$window',
    function ($window) {
      var $countUp = $window.countUp;

      $countUp.prototype.$start = function () {
        var deferred = Promise.defer();
        this.start(deferred.resolve.bind(deferred));
        return deferred.promise;
      };

      return $countUp;
    }])
  .directive("countUp", [
    '$countUp',
    function ($countUp) {
      return {
        restrict: "A",
        require: "ngModel",
        scope: true,
        link: function ($scope, $element, $attrs) {
          var duration, decimals, options, hasAnimated = false;

          // defaults
          decimals = 0;
          duration = 2;
          options = {
            useEasing: true, // toggle easing
            useGrouping: true, // 1,000,000 vs 1000000
            separator: ',', // character to use as a separator
            decimal: '.' // character to use as a decimal
          };

          //optional overrides
          if (typeof $attrs.cuDecimals !== 'undefined' && $attrs.cuDecimals >= 0) {
            decimals = $attrs.cuDecimals;
          }

          if (typeof $attrs.cuDuration !== 'undefined' && $attrs.cuDuration > 0) {
            duration = $attrs.cuDuration;
          }

          if (typeof $attrs.cuUseEasing !== 'undefined' && typeof $attrs.cuUseEasing === 'boolean') {
            options.useEasing = $attrs.cuUseEasing;
          }

          if (typeof $attrs.cuUseGrouping !== 'undefined' && typeof $attrs.cuUseGrouping === 'boolean') {
            options.useGrouping = $attrs.cuUseGrouping;
          }

          if (typeof $attrs.cuSeparator !== 'undefined' && typeof $attrs.cuSeparator === 'string') {
            options.separator = $attrs.cuSeparator;
          }

          if (typeof $attrs.cuDecimal !== 'undefined' && typeof $attrs.cuDecimal === 'string') {
            options.decimal = $attrs.cuDecimal;
          }

          return $scope.$watch($attrs.ngModel, function (endVal, startVal) {
            if (!startVal || !hasAnimated) {
              startVal = 0;
            }
            if (endVal && (endVal !== startVal || !hasAnimated)) {
              hasAnimated = true;
              return new $countUp($element[0], startVal, endVal, decimals, duration, options).$start();
            }
          });
        }
      };
    }])
  .directive("countUpBar", ['$countUp', function ($countUp) {
    return {
      restrict: "A",
      require: "ngModel",
      link: function ($scope, $element, $attrs) {
        var duration, decimals, direction, options, hasAnimated = false;

        // defaults
        decimals = 0;
        duration = 2;
        direction = 'width';
        options = {
          useEasing: true, // toggle easing
          useGrouping: false, // 1,000,000 vs 1000000
          separator: '', // character to use as a separator
          decimal: '' // character to use as a decimal
        };

        //optional overrides
        if (typeof $attrs.cuDecimals !== 'undefined' && $attrs.cuDecimals >= 0) {
          decimals = $attrs.cuDecimals;
        }

        if (typeof $attrs.cuDuration !== 'undefined' && $attrs.cuDuration > 0) {
          duration = $attrs.cuDuration;
        }

        if (typeof $attrs.cuDirection !== 'undefined' && $attrs.cuDirection == 'height') {
          direction = 'height';
        }

        if (typeof $attrs.cuUseEasing !== 'undefined' && typeof $attrs.cuUseEasing === 'boolean') {
          options.useEasing = $attrs.cuUseEasing;
        }

        if (typeof $attrs.cuDecimal !== 'undefined' && typeof $attrs.cuDecimal === 'string') {
          options.decimal = $attrs.cuDecimal;
        }

        return $scope.$watch($attrs.ngModel, function (endVal, startVal) {
          if (!startVal || !hasAnimated) {
            startVal = 0;
          }
          if (endVal && (endVal !== startVal || !hasAnimated)) {
            hasAnimated = true;
            var anim = new $countUp({}, startVal, endVal, decimals, duration, options);
            var previousValue;
            anim.printValue = function printValue(value) {
              if (value != previousValue) {
                $attrs.$set('style', direction + ': ' + value + '%;');
                previousValue = value;
              }
            };
            return anim.$start();
          }
        });
      }
    };
  }]);


// WEBPACK FOOTER //
// ./src/js/core-utilities/countUp/index.js